<div id="content">
	<div id="main">
		<router-outlet></router-outlet>
	</div>
</div>
<bb-analytics-menu id="sidebar"></bb-analytics-menu>